/* global femcare, CountUp */

femcare.article.infographic = {
    init: function () {
        if ($('.infographic').length) {
            this.animationStarted = false;
            this.$animationStartline = $('.infographic__animation-startline');

            $(window).on('wheel scroll resize', $.proxy(this.conditionallyStartAnimation, this));
            this.conditionallyStartAnimation();
        }
    },

    conditionallyStartAnimation: function () {
        if (
            this.animationStarted === false &&
            femcare.shared.util.isElementInViewport(this.$animationStartline)
        ) {
            this.animationStarted = true;
            $(window).off('wheel scroll resize', this.conditionallyStartAnimation);
            this.animate();
        }
    },

    /** Prepare infographic and start them when in viewport. */
    animate: function () {
        $('.infographic-column').each(function () {
            var $this = $(this);
            var $progressCircle = $this.find('.infographic-column__circle');

            var fillPercent = $this.data('fill');
            fillPercent = fillPercent ? parseInt(fillPercent.toString().trim(), 10) : 100;

            var countUpTo = $this.data('countupto');
            countUpTo = countUpTo ? parseInt(countUpTo.toString().trim(), 10) : null;
            var counter = null;

            if (countUpTo) {
                counter = new CountUp(
                    $this.find('.infographic-column__stats span')[0],
                    0,
                    countUpTo,
                    0,
                    2,
                    {
                        useEasing: true,
                        useGrouping: true
                    }
                );
            }

            var canvasSupport = !!window.HTMLCanvasElement;

            // Start the countUp.
            setTimeout(function () {
                if (counter) {
                    counter.start();
                }

                if (canvasSupport) {
                    // Start animate the circle progress.
                    $progressCircle.circleProgress({
                        value: fillPercent / 100,
                        size: 215,
                        thickness: 4,
                        startAngle: Math.PI - 67.5,
                        fill: {
                            gradient: ['#e31d93', ['#ef5a9e', 0.54], '#e31d1d']
                        },
                        emptyFill: '#dddddd'
                    });
                }
            }, 10);
        });
    }
};
